module.exports = __webpack_public_path__ + "static/media/speculant.58ba9d42.svg";